import { render, staticRenderFns } from "./WhatsAppContactMessage.vue?vue&type=template&id=5ec4009b&scoped=true&"
import script from "./WhatsAppContactMessage.vue?vue&type=script&lang=js&"
export * from "./WhatsAppContactMessage.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppContactMessage.vue?vue&type=style&index=0&id=5ec4009b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4009b",
  null
  
)

export default component.exports